import { useReactiveVar } from '@apollo/client';
import { isDarkMode } from 'src/state/reactiveVars';

export const useIsDarkMode = (): boolean => {
    const darkMode = useReactiveVar(isDarkMode);
    return darkMode;
};

export default useIsDarkMode;
